import getConfig from 'next/config';

const config = getConfig();

const FACEBOOK_API_ID = config ? config.publicRuntimeConfig.facebookApiId : '';

export default FACEBOOK_API_ID;
